<template>
  <Dashboard
    class="questions"
    title="Questions"
  >
    <Button
      class="questions--add-button"
      title="Add question"
      to=""
      active=true
      showAddIcon=true
      v-on:handleClick="handleModal({}, 'Add', 0)"
    />

    <Table
      recordsfoundishidden=true
      :data="questions"
      :isloading="isLoading"
      v-if="selectedApplicationId"
    >
      <template v-slot:titles>
        <th>ID</th>
        <th>Question</th>
        <th></th>
      </template>

      <template v-slot:row>
        <tr
          @dragover="(e) => onDragOver(item, index, e)" 
          @dragend="(e) => finishDrag(item, index, e)"
          @dragstart="(e) => startDrag(item, index, e)"
          v-for="(item, index) of questions"
          class="item table--content"
          :class="{
            over: (item === over.item && item !== dragFrom),
            [over.dir]: (item === over.item && item !== dragFrom)
          }"
          draggable="true"
          v-bind:key="index"
        >
          <TdId :id="item.id"/>

          <TdTitle              
            :title="item.question"
          />

          <TdButtons>
            <RoundedButton
              title="Options"                
              v-on:handleClick="handleOptionsButton(item.id)"
            />

            <RoundedButton
              title="Edit"
              v-on:handleClick="handleModal(item, 'Edit', index)"
            >
              <EditIcon/>
            </RoundedButton>

            <RoundedButton
              title=""
              danger=true
              v-on:handleClick="handleDelete(item.id, index)"
            >
              <TrashIcon/>
            </RoundedButton>
          </TdButtons>
        </tr>
      </template>
    </Table>

    <NoApplicationSelected v-else/>

    <Modal 
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>{{ modal.title }} Question</h3>
      </template>

      <template v-slot:content>
        <form>
          <div class="row">
            <div
              v-if="!modal.data.isTextfield"
              class="col-24"
            >
              <div class="row">
                <Input
                  class="col-24"
                  placeholder="Question"
                  type="text"
                  :value="modal.data.question"
                  v-model="modal.data.question"
                />

                <!-- type select -->
                <div class="col-24 input">
                  <p>Type</p>

                  <div class="row">
                    <div class="col-12 col-24-sm">
                      <RadioInput
                        placeholder="Checkbox"
                        name="radio"
                        :checked="modal.data.type === 'checkbox'"
                        v-on:handleClick="handleRadioInput('checkbox')"
                      />

                      <RadioInput
                        placeholder="Date"
                        name="radio"
                        :checked="modal.data.type === 'datum'"
                        v-on:handleClick="handleRadioInput('datum')"
                      />

                      <RadioInput
                        placeholder="Display"
                        name="radio"
                        :checked="modal.data.type === 'display'"
                        v-on:handleClick="handleRadioInput('display')"
                      />

                      <RadioInput
                        placeholder="Memo"
                        name="radio"
                        :checked="modal.data.type === 'memo'"
                        v-on:handleClick="handleRadioInput('memo')"
                      />
                    </div>

                    <div class="col-12 col=24-sm">
                      <RadioInput
                        placeholder="Number"
                        name="radio"
                        :checked="modal.data.type === 'number'"
                        v-on:handleClick="handleRadioInput('number')"
                      />

                      <RadioInput
                        placeholder="Radio"
                        name="radio"
                        :checked="modal.data.type === 'radio'"
                        v-on:handleClick="handleRadioInput('radio')"
                      />

                      <RadioInput
                        placeholder="Range"
                        name="radio"
                        :checked="modal.data.type === 'range'"
                        v-on:handleClick="handleRadioInput('range')"
                      />

                      <RadioInput
                        placeholder="Text"
                        name="radio"
                        :checked="modal.data.type === 'text'"
                        v-on:handleClick="handleRadioInput('text')"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-12 input">
                  <p>Is required</p>

                  <SwitchForm
                    :isActive="modal.data.isRequired"
                    v-model="modal.data.isRequired"
                  />
                </div>

                <div class="col-12 input">
                  <p>Is one time answer</p>

                  <SwitchForm
                    :isActive="modal.data.isOnetimeAnswer"
                    v-model="modal.data.isOnetimeAnswer"
                  />
                </div>

                <Input
                  class="col-12"
                  placeholder="Placeholder"
                  type="text"
                  :value="modal.data.note"
                  v-model="modal.data.note"
                />

                <Input
                  class="col-12"
                  placeholder="Label"
                  type="text"
                  :value="modal.data.label"
                  v-model="modal.data.label"
                />
              </div>
            </div>

            <div class="col-12 input">
              <p>Is textfield</p>

              <SwitchForm
                :isActive="modal.data.isTextfield"
                v-model="modal.data.isTextfield"
              />
            </div>

            <vue-mce
              v-if="modal.data.isTextfield"
              class="col-24"
              :config="config"
              v-model="modal.data.displaytext"
            />
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>      
    </Modal>
  </Dashboard>
</template>

<script>
  import { API } from '../../../../services/api.ts'
  import Dashboard from '../../../../components/dashboard/dashboard.vue'
  import Button from '../../../../components/buttons/button.vue'
  import RoundedButton from '../../../../components/buttons/roundedButton.vue'
  import NoApplicationSelected from '../../../../components/error/noApplicationSelected.vue'
  import Modal from '../../../../components/modal/modal.vue'
  import Input from '../../../../components/form/input.vue'
  import RadioInput from '../../../../components/form/radio.vue'
  import ButtonForm from '../../../../components/form/button.vue'

  import Table from '../../../../components/table/table.vue'
  import TdTitle from '../../../../components/table/td/title.vue'
  import TdId from '../../../../components/table/td/id.vue'
  import TdSortOrder from '../../../../components/table/td/sortOrder.vue'
  import TdButtons from '../../../../components/table/td/buttons.vue'
  import TrashIcon from '../../../../icons/trash.vue'
  import EditIcon from '../../../../icons/edit.vue'
  import SwitchForm from '../../../../components/form/switch.vue'
  import { component } from 'vue-mce'

  export default {
    name: 'Questions',
    components: {
      Dashboard,
      Button,
      RoundedButton,
      NoApplicationSelected,
      Modal,
      Input,
      RadioInput,
      ButtonForm,
      Table,
      TdTitle,
      TdId,
      TdSortOrder,
      TdButtons,
      TrashIcon,
      EditIcon,
      SwitchForm,
      'vue-mce': component
    },
    data() {
      return {
        config: {
          theme: 'modern',          
          menubar: false,
          plugins: 'code lists link',
          toolbar: 'styleselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code',
          style_formats : [
            {title : 'H2', block : 'h2'},
            {title : 'H3', block : 'h3'},
            {title : 'H4', block : 'h4'},
            {title: 'Color block', inline: 'span', classes: 'well', styles: { backgroundColor: 'whitesmoke', display: 'block'}},
            {title : 'Quotation', block : 'blockquote'},
          ]
        },
        selectedApplicationId: localStorage.selectedApplicationId,
        isLoading: true,
        questions: [],
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
        modal: {
          isHidden: true,
          title: '',
          index: 0,
          data: {}
        }
      }
    },
    methods: {
      startDrag(item, i, e) {
        this.startLoc = e.clientY;
        this.dragging = true;
        this.dragFrom = item;
      },
      finishDrag(item, pos) {
        this.questions.splice(pos, 1)
        this.questions.splice(this.over.pos, 0, item);
        this.over = {}

        for (const [index, item] of this.questions.entries()) {
          item.rank = index + 1;

          API.patch(
            `index.cfm?act=questionnairequestions.item&id=${item.id}`,
            {
              rank: `${index + 1}`
            }
          ).then(
            response => {
              console.log(response.data.data);
            }
          )
        }
      },
      onDragOver(item, pos, e) {
        const dir = (this.startLoc < e.clientY) ? 'down': 'up';
        setTimeout(() => {
          this.over = { item, pos, dir };        
        }, 10)
      },
      handleOptionsButton: function(id) {
        window.location.href = `/questionnaires/sections/${this.$route.params.id}/questions/${this.$route.params.questionid}/options/${id}`;
      },
      handleModal: function(item, title, index) {
        this.modal.title = title;

        if (title === 'Add') {
          if (this.modal.isHidden === true) {
            this.modal.isHidden = false;
            this.modal.data = {
              id: 0,
              isOnetimeAnswer: false,
              isRequired: false,
              isTextfield: false,
              label: '',
              note: '',
              question: '',
              rank: '',
              type: ''
            }
          } else {
            this.modal.isHidden = true;
          }
        } else {
          if (this.modal.isHidden === true) {
            this.modal.index = index;
            
            API.get(
              `index.cfm?act=questionnairequestions.item&id=${item.id}`
            ).then(
              response => {
                console.log(response.data.data);
                
                this.modal.data = response.data.data;
                this.modal.isHidden = false;
              }
            )
          } else {
            this.modal.isHidden = true;
          }
        }
      },
      handleModalButton: function() {
        if (this.modal.title === 'Add') {
          API.post(
            `index.cfm?act=questionnairequestions.item&sectionid=${this.$route.params.questionid}`,
            {
              question: this.modal.data.question,
              label: this.modal.data.label,
              type: this.modal.data.type,
              isRequired: this.modal.data.isRequired,
              isTextfield: this.modal.data.isTextfield,
              note: this.modal.data.note,
              displaytext: this.modal.data.displaytext,
              isOnetimeAnswer: this.modal.data.isOnetimeAnswer
            }
          ).then(
            response => {
              location.reload();
            }
          )
        } else {
          API.patch(
            `index.cfm?act=questionnairequestions.item&id=${this.modal.data.id}`,
            {
              question: this.modal.data.question,
              label: this.modal.data.label,
              type: this.modal.data.type,
              isRequired: this.modal.data.isRequired,
              isTextfield: this.modal.data.isTextfield,
              note: this.modal.data.note,
              displaytext: this.modal.data.displaytext,
              isOnetimeAnswer: this.modal.data.isOnetimeAnswer
            }
          ).then(
            response => {              
              this.questions[this.modal.index].question = response.data.data.question;
              this.modal.isHidden = true;
            }
          )
        }
      },
      handleRadioInput: function(type) {
        this.modal.data.type = type;
      },
      handleDelete: function(id, index) {
        if (confirm("Are you sure you want to delete this section?")) {
          API.delete(
            `index.cfm?act=questionnairequestions.item&id=${id}`
          ).then(
            response => {
              this.questions.splice(index, 1);
            }
          )
        }
      },
    },
    mounted() {
      const self = this;
      
      API.get(
      `index.cfm?act=questionnairequestions.list&id=${this.$route.params.questionid}`
      ).then(
        response => {
          console.log(response.data.data);
          this.questions = response.data.data;
          this.isLoading = false;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');        
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  .questions {
    &--add-button {
      float: right;
    }

    .table {
      float: left;
    }

    .switch {
      margin-bottom: 15px;
    }
  }
</style>
